module.exports = __webpack_public_path__ + "assets/img/option-empty-video.6e600cbf.svg";